@if (view() === 'tab') {
  <div class="d-flex btn-group view-tab" role="group">
    @for (option of options(); track option.title) {
      <button
        type="button"
        class="btn"
        data-test="button-group-selector-option-button"
        [disabled]="disabled()"
        (click)="onSelect(option.value)"
        [class.selected]="isSelected(option)"
        [matTooltip]="option.tooltip"
      >
        @if (option.icon) {
          <i [class]="'fa-fw ' + option.icon"></i>
          @if (!hideTitle()) {
            <span> {{ option.title }} </span>
          }
        } @else if (!hideTitle()) {
          {{ option.title }}
        }
      </button>
    }
  </div>
} @else {
  <sk-button-group>
    @for (option of options(); track option.title) {
      <sk-button [label]="hideTitle() ? '' : option.title"
                 [disabled]="disabled()"
                 data-test="button-group-selector-option-button"
                 (click)="onSelect(option.value)"
                 [active]="isSelected(option)"
                 [suppressMinWidth]="suppressButtonsMinWidth()"
                 [matTooltip]="option.tooltip">
        @if (option.icon) {
          <ng-template buttonPrefix>
            <i [class]="'icon fa-fw ' + option.icon"></i>
          </ng-template>
        }
      </sk-button>
    }

  </sk-button-group>
}
